import { inject, ref, type InjectionKey, type Ref } from 'vue'

import { resolveZendeskScript } from '@/templates/config'

export const zendeskScriptKey: InjectionKey<Readonly<Ref<string>>> = Symbol('zendeskScript')

export const useZendeskScript = (): Readonly<Ref<string>> => inject(
  zendeskScriptKey,
  ref(resolveZendeskScript(import.meta.env.VITE_TEMPLATE_ID, import.meta.env.PROD)),
)
